// routes.tsx
import { RouteObject } from 'react-router-dom';
import WelcomePage from '../../views/welcomePage/WelcomePage';
import Login from '../../views/Authentication/Login';
import Register from '../../views/Authentication/Register';
import SendConfirmEmail from '../../views/Authentication/SendConfirmEmail';
import ReceiveConfirmEmail from '../../views/Authentication/ReceiveConfirmEmail';
import PasswordRecovery from '../../views/Authentication/passwordRecovery/PasswordRecovery';
import PasswordUpdate from '../../views/Authentication/PasswordUpdate';
import HelpDeleteAccount from '../../views/Authentication/HelpDeleteAccount';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <WelcomePage />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/registo',
    element: <Register />,
  },
  {
    path: '/send-confirm-email',
    element: <SendConfirmEmail />,
  },
  {
    path: '/confirm-email/:token',
    element: <ReceiveConfirmEmail />,
  },
  {
    path: '/recuperar-password',
    element: <PasswordRecovery />,
  },
  {
    path: '/send-email-password',
    element: <PasswordRecovery emailSent={true} />,
  },
  {
    path: '/definir-password/:token',
    element: <PasswordUpdate />,
  },
  {
    path: '/help-delete-account',
    element: <HelpDeleteAccount />,
  },
];

export default routes;